import getAlternatePlate from './getAlternatePlate';
import getVehicleGroupKey from './getVehicleGroupKey';

export interface IVehicles {
  getVehicleGroupKey(detection: { id: number; plate?: string | null }): string;
  getAlternatePlate(detection: NonNullable<VideoStreamEvent['metadata']>['detection'], plate?: string): string | undefined;
}

const Vehicles: IVehicles = {
  getVehicleGroupKey,
  getAlternatePlate
}

export default Vehicles;
